/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, {lazy} from 'react'
import {Redirect} from 'react-router-dom'
import AuthLayout from './layouts/Auth'
import ErrorLayout from './layouts/Error'
import DashboardLayout from './layouts/Dashboard'

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard"/>
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [{
      path: '/dashboard',
      exact: true,
      component: lazy(() => import('src/screens/manager/dashboard/Dashboard'))
    }, {
      path: '/dashboard/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/dashboard/DashboardDetails'))
    }, {
      path: '/employee/maintenance/orders',
      exact: true,
      component: lazy(() => import('src/screens/employee/maintenance/orders/Orders'))
    }, {
      path: '/employee/maintenance/orders/:id',
      exact: true,
      component: lazy(() => import('src/screens/employee/maintenance/orders/OrdersDetails'))
    }, {
      path: '/employee/periodic/maintenance',
      exact: true,
      component: lazy(() => import('src/screens/employee/periodic/orders/Orders'))
    }, {
      path: '/employee/periodic/maintenance/:id',
      exact: true,
      component: lazy(() => import('src/screens/employee/periodic/orders/OrdersDetails'))
    }, {
      path: '/employee/spare/orders',
      exact: true,
      component: lazy(() => import('src/screens/employee/spare/orders/Orders'))
    }, {
      path: '/employee/spare/orders/:id',
      exact: true,
      component: lazy(() => import('src/screens/employee/spare/orders/OrdersDetails'))
    }, {
      path: '/maintenance/orders',
      exact: true,
      component: lazy(() => import('src/screens/manager/maintenance/orders/Orders'))
    }, {
      path: '/maintenance/orders/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/maintenance/orders/OrdersDetails'))
    }, {
      path: '/spare/orders',
      exact: true,
      component: lazy(() => import('src/screens/manager/spare/orders/Orders'))
    }, {
      path: '/spare/orders/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/spare/orders/OrdersDetails'))
    }, {
      path: '/achievement/certificates',
      exact: true,
      component: lazy(() => import('src/screens/manager/achievement/certificates/Certificates'))
    }, {
      path: '/achievement/certificates/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/achievement/certificates/CertificatesDetails'))
    }, {
      path: '/quotations',
      exact: true,
      component: lazy(() => import('src/screens/manager/quotations/Quotations'))
    }, {
      path: '/quotations/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/quotations/QuotationsDetails'))
    }, {
      path: '/periodic/maintenance',
      exact: true,
      component: lazy(() => import('src/screens/manager/periodic/maintenance/Maintenance'))
    }, {
      path: '/periodic/maintenance/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/periodic/maintenance/MaintenanceDetails'))
    }, {
      path: '/files',
      exact: true,
      component: lazy(() => import('src/screens/manager/files/Files'))
    }, {
      path: '/files/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/files/FilesDetails'))
    }, {
      path: '/inventory',
      exact: true,
      component: lazy(() => import('src/screens/manager/inventory/Inventory'))
    }, {
      path: '/inventory/records',
      exact: true,
      component: lazy(() => import('src/screens/manager/inventory/records/Records'))
    }, {
      path: '/inventory/records/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/inventory/records/RecordsDetails'))
    }, {
      path: '/inventory/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/inventory/InventoryDetails'))
    }, {
      path: '/reports/orders',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/orders/Orders'))
    }, {
      path: '/reports/orders/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/orders/OrdersDetails'))
    }, {
      path: '/reports/maintenance/orders',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/maintenance/orders/Orders'))
    }, {
      path: '/reports/maintenance/orders/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/maintenance/orders/OrdersDetails'))
    }, {
      path: '/reports/quotations',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/quotations/Quotations'))
    }, {
      path: '/reports/quotations/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/quotations/QuotationsDetails'))
    }, {
      path: '/reports/periodic/maintenance',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/periodic/maintenance/Maintenance'))
    }, {
      path: '/reports/periodic/maintenance/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/periodic/maintenance/MaintenanceDetails'))
    }, {
      path: '/reports/achievement/certificates',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/achievement/certificates/Certificates'))
    }, {
      path: '/reports/achievement/certificates/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/achievement/certificates/CertificatesDetails'))
    }, {
      path: '/reports',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/Reports'))
    }, {
      path: '/reports/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/reports/ReportsDetails'))
    }, {
      path: '/settings/regions',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/regions/Regions'))
    }, {
      path: '/settings/regions/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/regions/RegionsDetails'))
    }, {
      path: '/settings/sites',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/sites/Sites'))
    }, {
      path: '/settings/sites/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/sites/SitesDetails'))
    }, {
      path: '/settings/units',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/units/Units'))
    }, {
      path: '/settings/units/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/units/UnitsDetails'))
    }, {
      path: '/settings/certificate/items',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/certificate/items/Items'))
    }, {
      path: '/settings/certificate/items/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/certificate/items/ItemsDetails'))
    }, {
      path: '/settings/inventory/items',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/inventory/items/Items'))
    }, {
      path: '/settings/inventory/items/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/inventory/items/ItemsDetails'))
    }, {
      path: '/settings/categories',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/categories/Categories'))
    }, {
      path: '/settings/categories/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/categories/CategoriesDetails'))
    }, {
      path: '/settings/periodic/items',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/periodic/items/Items'))
    }, {
      path: '/settings/periodic/items/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/periodic/items/ItemsDetails'))
    }, {
      path: '/settings',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/Settings'))
    }, {
      path: '/settings/:id',
      exact: true,
      component: lazy(() => import('src/screens/manager/settings/SettingsDetails'))
    }, {
      path: '/user/management/roles',
      exact: true,
      component: lazy(() => import('src/views/UserManagementRoles'))
    }, {
      path: '/user/management/roles/:id',
      exact: true,
      component: lazy(() => import('src/views/UserManagementRoles/UserManagementRolesDetails'))
    }, {
      path: '/user/management/users',
      exact: true,
      component: lazy(() => import('src/views/UserManagementUsers'))
    }, {
      path: '/user/management/users/:id',
      exact: true,
      component: lazy(() => import('src/views/UserManagementUsers/UserManagementUsersDetails'))
    }, {
      path: '/dashboard',
      exact: true,
      component: lazy(() => import('src/screens/dashboard/Dashboard'))
    },
      /* START_ROUTES */{
        path: '/dashboard',
        exact: true,
        component: lazy(() => import('src/screens/dashboard/Dashboard'))
      }, {
        path: '/dashboard/:id',
        exact: true,
        component: lazy(() => import('src/screens/dashboard/DashboardDetails'))
      }, {
        path: '/officer/maintenance/orders',
        exact: true,
        component: lazy(() => import('src/screens/officer/maintenance/orders/Orders'))
      }, {
        path: '/officer/maintenance/orders/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/maintenance/orders/OrdersDetails'))
      }, {
        path: '/officer/spare/orders',
        exact: true,
        component: lazy(() => import('src/screens/officer/spare/orders/Orders'))
      }, {
        path: '/officer/spare/orders/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/spare/orders/OrdersDetails'))
      }, {
        path: '/officer/achievement/certificates',
        exact: true,
        component: lazy(() => import('src/screens/officer/achievement/certificates/Certificates'))
      }, {
        path: '/officer/achievement/certificates/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/achievement/certificates/CertificatesDetails'))
      }, {
        path: '/officer/periodic/maintenance',
        exact: true,
        component: lazy(() => import('src/screens/officer/periodic/maintenance/Maintenance'))
      }, {
        path: '/officer/periodic/maintenance/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/periodic/maintenance/MaintenanceDetails'))
      }, {
        path: '/officer/inventory/records',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/records/Records'))
      }, {
        path: '/officer/inventory/records/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/records/RecordsDetails'))
      }, {
        path: '/officer/inventory/items',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/items/Items'))
      }, {
        path: '/officer/inventory/items/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/items/ItemsDetails'))
      }, {
        path: '/officer/inventory',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/Inventory'))
      }, {
        path: '/officer/inventory/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/InventoryDetails'))
      },
      {
        path: '/officer/signature',
        exact: true,
        component: lazy(() => import('src/screens/officer/signature/Signature'))
      },
      /* END_ROUTES */
      {
        path: '/supervisor/signature',
        exact: true,
        component: lazy(() => import('src/screens/officer/signature/Signature'))
      },
      {
        path: '/supervisor/files',
        exact: true,
        component: lazy(() => import('src/screens/officer/files/Files'))
      },
      {
        path: '/supervisor/maintenance/orders',
        exact: true,
        component: lazy(() => import('src/screens/officer/maintenance/orders/Orders'))
      }, {
        path: '/supervisor/maintenance/orders/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/maintenance/orders/OrdersDetails'))
      }, {
        path: '/supervisor/spare/orders',
        exact: true,
        component: lazy(() => import('src/screens/officer/spare/orders/Orders'))
      }, {
        path: '/supervisor/spare/orders/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/spare/orders/OrdersDetails'))
      }, {
        path: '/supervisor/achievement/certificates',
        exact: true,
        component: lazy(() => import('src/screens/officer/achievement/certificates/Certificates'))
      }, {
        path: '/supervisor/achievement/certificates/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/achievement/certificates/CertificatesDetails'))
      }, {
        path: '/supervisor/periodic/maintenance',
        exact: true,
        component: lazy(() => import('src/screens/officer/periodic/maintenance/Maintenance'))
      }, {
        path: '/supervisor/periodic/maintenance/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/periodic/maintenance/MaintenanceDetails'))
      }, {
        path: '/supervisor/inventory/records',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/records/Records'))
      }, {
        path: '/supervisor/inventory/records/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/records/RecordsDetails'))
      }, {
        path: '/supervisor/inventory/items',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/items/Items'))
      }, {
        path: '/supervisor/inventory/items/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/items/ItemsDetails'))
      }, {
        path: '/supervisor/inventory',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/Inventory'))
      }, {
        path: '/supervisor/inventory/:id',
        exact: true,
        component: lazy(() => import('src/screens/officer/inventory/InventoryDetails'))
      },





      {
        component: () => <Redirect to="/errors/error-404"/>
      }
    ]
  }
]
